import React, { useEffect, useState } from 'react'
import './linkSet.scss'
import { Input, Field, Button, Text } from '@fluentui/react-components';
import { Delete24Regular } from '@fluentui/react-icons';
import { enableMultiSpaces } from '../../AdaptiveCard/adaptiveCard';

export interface IAction {
    title: string,
    link: string,
    isEvent: boolean,
}

export const checkUrlError = (url: string): boolean => {
    const isError: boolean = !((url === "")
        || (url.startsWith("https://")
            || (url.startsWith("data:image/png;base64,"))
            || (url.startsWith("data:image/jpeg;base64,"))
            || (url.startsWith("data:image/gif;base64,"))))
    return isError;
}

interface IListSetProps {
    onChange: (actions: IAction[]) => void;
    value: IAction[];
}

const LinkSet = (props: IListSetProps) => {
    const [actions, setActions] = useState<IAction[]>(props.value);

    useEffect(() => {
        setActions(props.value)
    }, [props.value])


    useEffect(() => {
        props.onChange(actions);
    }, [actions])

    const addButton = () => {
        let urlsAndEvents = [...actions, { title: "", link: "", isEvent: false }]
        urlsAndEvents = urlsAndEvents.sort((a, b) => (a === b) ? 0 : a ? 1 : -1); //swap -1 and 1 to change order of event and links
        setActions(urlsAndEvents);
    }

    const changeUrl = (i: number, type: string, value: any) => {
        let newActions = [...actions];


        if (type === "link") {
            newActions[i] = { title: actions[i].title ?? "", link: value, isEvent: false } as IAction;
        } else {
            const title = value ? enableMultiSpaces(value) : value
            newActions[i] = { title: title, link: actions[i].link ?? "", isEvent: false } as IAction;
        }

        setActions(newActions)
    }

    return (
        <div className='link-set'>
            <div>
                {
                    actions.map((el: any, i) => (
                        <div className='linkContainer' key={i}>
                            <div className='linkInputContainer'>
                                <Field label="Button name">
                                    <Input
                                        className="inputField-button"
                                        value={el.title || ""}
                                        onChange={(_, data) => changeUrl(i, "title", data.value)}
                                        autoComplete="off"
                                        required
                                    />
                                </Field>
                            </div>
                            <div className='linkInputContainer'>
                                <Field label="URL"
                                >
                                    <Input
                                        className="inputField-button"
                                        value={el.link || ""}
                                        onChange={(_, data) => changeUrl(i, "link", data.value)}
                                        autoComplete="off"
                                        required
                                    />
                                </Field>
                                <Text className='errorText'>{checkUrlError(el.link) ? "Invalid URL" : ""}</Text>
                            </div>
                            <Button onClick={() => {
                                var newActions = [...actions];
                                newActions = actions.filter((_, index) => i !== index);
                                setActions(newActions);
                            }} icon={<Delete24Regular />} className='linkDeleteButtton' />
                        </div>
                    ))
                }
            </div>

            <Button disabled={actions.length > 4} type='button' onClick={() => addButton()}>Add button</Button>
        </div>
    )
}

export default LinkSet;